// extracted by mini-css-extract-plugin
export default {"emptyState":"empty_state-module___emptyState___f4e1c393","title":"empty_state-module___title___a7dc15ba"};